// extracted by css-extract-rspack-plugin
var _1 = "zAM0XLYW0oJbRy_P";
var _2 = "ZrPdY76B7t06ADp0";
var _3 = "ZrPdY76B7t06ADp0";
var _4 = "YCpCjsaSl4UULV_B";
var _5 = "Izs3xUxQnaAb33It";
var _6 = "dpkx3g2SzY4GqExO";
var _7 = "dpkx3g2SzY4GqExO";
export { _1 as "button", _2 as "category-box", _3 as "categoryBox", _4 as "dialog", _5 as "price", _6 as "title-box", _7 as "titleBox" }
